import { Box, Button, Checkbox, Container, Flex, Grid, GridItem, Heading, IconButton, Link, Text, useDisclosure } from '@chakra-ui/react';
import { useFormik } from 'formik';
import HtmlToReact from 'html-to-react';
import { useCallback, useEffect, useMemo } from 'react';
import { HiArrowLeft } from 'react-icons/hi2';
import { parsePhoneNumber } from 'react-phone-number-input';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import ModalLoading from '../../../../components/Loader/ModalLoader';
import NavigationScroll from '../../../../components/Navigation/NavigationScroll';
import { urlNavigate } from '../../../../helper/utils/navigation';
import { tncShortPartyPPI } from '../../../../mock/tnc_short_party_ppi_tsi';
import { tncShortPartySPI } from '../../../../mock/tnc_short_party_spi';
import { doHandleCreateOrder } from '../../../../redux/onlineSales/onlineSales.actions';
import { doSubmission } from '../../../../redux/waiver/waiver.actions';
import ModalConfirm from '../../components/ModalConfirm';
import ModalSignWaiver from '../../components/ModalSignWaiver';
import ProductCarts from '../../components/ProductCarts';
import useCartDatas from '../../hooks/useCartDatas';
import useOnlineSales from '../../hooks/useOnlineSales';
import usePages from '../../hooks/usePages';
import useSubscriptionCheckBeforeOrder from '../../hooks/useSubscriptionCheckBeforeOrder';
import CustomerFormParty from './widget/CustomerFormParty';
import CustomerInformation from './widget/CustomerInformation';

const HtmlToReactParser = HtmlToReact.Parser;
export default function CheckoutPage() {
    const { cart, navigate, dispatch } = useCartDatas();
    const { isOpen, onClose, onOpen } = useDisclosure();
    const { isOpen: isOpenSign, onClose: onCloseSign, onOpen: onOpenSign } = useDisclosure();
    const { loadingOrder } = useOnlineSales();
    const { isVerifiedWaiver = false, isRegisterWaiver = false, minor = [], loadingSubmission = false, waiver = {} } = useSelector((s) => s?.waiver);
    const { checkSubscriptionBeforeOrder } = useSubscriptionCheckBeforeOrder({
        cart,
        waiverId: waiver?.id || '',
    });
    const { page } = usePages();
    const pageId = useMemo(() => (page?.['id'] || '').toString().trim().toLowerCase(), [page]);
    const isPartyMenu = cart?.some((item) => (item?.['menuType'] || '').toString().trim().toLowerCase() == 'party');

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            discount: '',
            fullname: '',
            birthDate: '',
            country: { value: 'ID', label: 'Indonesia' },
            city: {},
            address: '',
            minors: [],
            forNewsletter: false,
            forTnc: false,
            forTncParty: false,
            partyName: '',
            celebrantName: '',
            celebrantAge: '',
            remarks: '',
        },
        onSubmit: async (values) => {
            onClose();

            if (isRegisterWaiver) {
                onOpenSign();
                return;
            }

            const handled = await checkSubscriptionBeforeOrder({
                values,
                onVerified: (latestValues) => {
                    dispatch(doHandleCreateOrder(latestValues));
                },
            });

            if (handled) return;

            dispatch(doHandleCreateOrder(values));
        },
    });

    const getDisabledButtonPay = useCallback(() => {
        if (!isVerifiedWaiver && !isRegisterWaiver) return true;
        if (isPartyMenu && !formik.values.forTncParty) return true;
        if (!formik.values.forTnc) return true;

        if (isPartyMenu) {
            if (formik.values.partyName.trim() === '') return true;
            if (formik.values.celebrantName.trim() === '') return true;
            if (formik.values.celebrantAge === '') return true;
            if (formik.values.remarks.trim() === '') return true;
            if (!formik.values.forTncParty) return true;
        }

        return false;
    }, [formik.values, isVerifiedWaiver, isRegisterWaiver]);

    useEffect(() => {
        if (cart.length < 1) {
            navigate(`${urlNavigate('online-sales', 'home')}`);
        }
    }, []);

    useEffect(() => {
        if (Object.keys(waiver).length > 0) {
            formik.setValues({
                firstName: waiver['fullname'] || '',
                lastName: waiver['fullname'] || '',
                email: waiver['email'] || '',
                phone: waiver['phone'] || '',
                discount: 0,
                fullname: waiver['fullname'] || '',
                birthDate: waiver['birthDate'] || '',
                address: waiver['address'] || '',
                country: {},
                city: {},
                minors: minor,
            });
        }
    }, [waiver]);

    return (
        <NavigationScroll>
            <Container maxW='7xl' my={16} p={0}>
                <ModalLoading loading={loadingSubmission || loadingOrder} />
                <Grid
                    w='full'
                    gridTemplateColumns={{
                        base: 'repeat(1, 1fr)',
                        md: 'repeat(12, 1fr)',
                    }}
                    gap={5}>
                    <GridItem colSpan={{ base: 1, md: 8 }}>
                        <form onSubmit={formik.handleSubmit}>
                            <Box bg='white' rounded='xl' border='1px' borderColor='gray.100' p={5} h='max-content'>
                                <Box w='full'>
                                    <Flex w='full' alignItems='center' gap={5}>
                                        <IconButton icon={<HiArrowLeft />} onClick={() => navigate(`${urlNavigate('online-sales', 'home')}`)} />
                                        <Heading fontSize='3xl' fontWeight={600} p={0}>
                                            Your Details
                                        </Heading>
                                    </Flex>
                                </Box>
                                {/* <InfoCard /> */}
                                <CustomerInformation formik={formik} isPartyMenu={isPartyMenu} />
                                {/* <Box w='full' mt={10}>
                                    <Heading fontSize='xl' fontWeight={700} mb={3}>
                                        Apply a discount
                                    </Heading>

                                    <Flex
                                        w='full'
                                        alignItems='end'
                                        flexDirection={{
                                            base: 'column',
                                            md: 'row',
                                        }}
                                        gap={3}>
                                        <Box w='full'>
                                            <Input py={6} mt={1} name='discount' id='discount' placeholder='Discount Code' onChange={formik.handleChange} onBlur={formik.handleBlur} />
                                        </Box>
                                        <Box w={{ base: 'full', md: 'max-content' }}>
                                            <Button
                                                colorScheme='primary'
                                                isDisabled
                                                w={{
                                                    base: 'full',
                                                    md: 'max-content',
                                                }}
                                                py={6}
                                                px={5}>
                                                Apply Code
                                            </Button>
                                        </Box>
                                    </Flex>
                                </Box> */}
                                {isPartyMenu && isVerifiedWaiver && <CustomerFormParty formik={formik} />}
                                {isPartyMenu && isVerifiedWaiver && (
                                    <Box w='full' mt={7} mb={3}>
                                        <Box>
                                            <Checkbox name='forTncParty' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.forTncParty}>
                                                * I acknowledge and agree to the terms and conditions provided below
                                            </Checkbox>
                                        </Box>

                                        <Box w='full' h='max-content' p={5} mt={3} rounded='lg' bg='white' border='1px' borderColor='gray.200'>
                                            {new HtmlToReactParser().parse(pageId == 'spi' ? tncShortPartySPI : tncShortPartyPPI)}
                                        </Box>
                                    </Box>
                                )}
                                {isVerifiedWaiver && (
                                    <Box w='full' display='flex' flexDirection='column' gap={3}>
                                        <Checkbox name='forNewsletter' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.forNewsletter}>
                                            Email me with news and offers
                                        </Checkbox>
                                        <Checkbox name='forTnc' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.forTnc}>
                                            * I have read and accept the{' '}
                                            <Link as={RouterLink} color='blue' to='/privacy-policy'>
                                                Term and Conditions
                                            </Link>{' '}
                                            and{' '}
                                            <Link as={RouterLink} color='blue' to='/privacy-policy'>
                                                Privacy Policy
                                            </Link>
                                        </Checkbox>
                                    </Box>
                                )}
                                {!getDisabledButtonPay() && isVerifiedWaiver && (
                                    <Box w='full' mt={10}>
                                        <Button w='full' p={7} type='button' isDisabled={getDisabledButtonPay()} colorScheme='green' isLoading={loadingOrder} onClick={onOpen}>
                                            Proceed to Check Out
                                        </Button>
                                    </Box>
                                )}
                                {getDisabledButtonPay() && isVerifiedWaiver && (
                                    <Box w='full' mt={10}>
                                        <Text color='red' textStyle=''>
                                            *Please fill in all the required information before proceeding with payment.
                                        </Text>
                                    </Box>
                                )}
                            </Box>
                        </form>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 4 }}>
                        <Flex w='full' flexDir='column' gap={4}>
                            {/* <SolQuestions /> */}
                            <ProductCarts />
                        </Flex>
                    </GridItem>
                </Grid>
            </Container>

            <ModalConfirm isOpen={isOpen} onClose={onClose} onConfirm={formik.submitForm} title='Order Confirmation' desc='Last chance to review! You will be redirected to the payment page. Paid orders cannot be canceled or refunded.' />
            <ModalSignWaiver
                isOpen={isOpenSign}
                onClose={onCloseSign}
                onConfirm={(signature) => {
                    const minors = minor.map((el) => ({ ...el, parentId: formik.values?.phone ?? '' }));

                    const payloadRegister = {
                        email: formik.values.email,
                        telp: `0${parsePhoneNumber(formik.values?.phone ?? '', 'ID')?.nationalNumber ?? ''}`,
                        birthDate: formik.values.birthDate,
                        signature: signature,
                        fullName: formik.values.fullname,
                        minor: minors,
                        isSubscribed: '1',
                        dialCode: `+${parsePhoneNumber(formik.values?.phone ?? '', 'ID')?.countryCallingCode ?? ''}`,
                        address: formik.values.address,
                        city: formik.values?.city?.value ?? '',
                        country: formik.values?.country?.value ?? '',
                    };

                    dispatch(
                        doSubmission(payloadRegister, null, () => {
                            dispatch(doHandleCreateOrder(values));
                        }),
                    );
                }}
            />
        </NavigationScroll>
    );
}
